import { InboxItem } from "modules/Messaging/Data/types";

export const getGroupMemberAvatar = (index: number, currentChat?: InboxItem) => {
	return currentChat && currentChat?.members?.length > index
		? currentChat.members[index]?.photos?.length
			? currentChat.members[index].photos[0]?.profilePicture
			: ""
		: "";
};
